const decodeQueryTextParam = (search: string): string | undefined => {
  try {
    return search && decodeURIComponent(search);
  } catch (e) {
    return undefined;
  }
};

export default decodeQueryTextParam;
